export default __webpack_public_path__ + "static/obstacle-position-example-5f29428b500e68e614bf72e27d74c900.png";